import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useMemberWallet} from "../../../hooks/useMemberWallet";
import {setComma, wonAndPercentFormat} from "../../../utils/format";
import {getRefundFeeInfo, refundPrepaidBalance} from "../../../api/transaction/refundApi";
import {RefundInfoType} from "../../../types/transaction/refund.info.type";
import {alertAfterFunction, defaultAlert, defaultConfirm} from "../../../utils/alert";
import {AccountInfo} from "../../../components/bank/AccountInfo";
import {Loading} from "../../../components/common/Loading";
import {BalanceArea} from "../../../components/bank/BalanceArea";


const RefundPage = () => {
    const navigate = useNavigate();
    const {memberWalletInfo, loading: walletLoading, error, refetch} = useMemberWallet();
    const [loading, setLoading] = useState(true);
    const [refundInfo, setRefundInfo] = useState<RefundInfoType>();
    const [showConditionModal, setShowConditionModal] = useState(false);


    useEffect(() => {
        getMemberRefundInfo();
    }, []);



    const getMemberRefundInfo = async () => {
        try {
            setLoading(true);
            const response = await getRefundFeeInfo();
            if (response.data?.code == "00") {
                setRefundInfo(response.data.data);
            }
        } catch (err) {
            console.error('Failed to fetch getMemberWalletBalance:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleRefund = () => {
        defaultConfirm("총 " + setComma(Math.floor(Number(refundInfo?.refundAmount))) + "원 환불 신청 하시겠습니까?", "신청", "취소",
            (isConfirmed) => {
                if (isConfirmed) {
                    refund();
                } else {
                    return;
                }
            }
        );
    }

    const refund = async () => {
        try {
            const response = await refundPrepaidBalance();
            if (response.data?.code === "00") {
                alertAfterFunction("잔액환불 신청이 완료되었습니다.", () => navigate('/wallet/refund-list'));
            }
        } catch (e) {
            defaultAlert("잔액 환불 신청에 실패했습니다.");
            return;
        }
    }

    if (!refundInfo) {
        return (
            <Loading loading={loading} onClose={() => setLoading(false)}/>
        );
    }



    return (
        <div>
            {showConditionModal && (
                <div className="popup_layer" onClick={() => setShowConditionModal(false)}>
                    <div className="popup_box" style={{maxWidth: '340px', padding: 0}} onClick={(e) => e.stopPropagation()}>
                        <div className="popup_cont">
                            <div className="guide-box">
                                <h3 className="point-tit">잔액환불 가능 조건</h3>
                                <p className="guide_txt mt10">최근 충전 후 아래 조건이 충족된 경우 잔액환불 신청이 가능합니다.</p>
                                <ul className="guidF-list mt10">
                                    <li>최근 충전 후 사용 이력 1회 이상</li>
                                    <li>최근 충전 시점의 보유잔액을 기준으로 사용률 {refundInfo.refundUsageRate ?? 60}% 이상</li>
                                    <li>사용률: 최근 충전 시점 보유잔액 / (최근 충전 시점 이후 사용금액 합계 - 잔액환불 신청 시점 예정잔액)</li>
                                    <li>예정잔액: 사용 후 취소되어 환급되어야 했지만, 선불수단 보유 한도 초과로 미충전된 환급금액</li>
                                </ul>
                                <p className="guide_txt mt10">최근 충전 후 사용 이력이 없고, 최근 충전일로부터 {refundInfo.chargeCancelDays ?? 7}일 이내인 충전금액은 충전취소가 가능합니다.</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="fullBtn" onClick={() => setShowConditionModal(false)}>닫기</button>
                        </div>
                    </div>
                </div>
            )}

            {refundInfo.refundAmount > 0 && (
                <div className="bottom-btn">
                    <button type="button" className="btn confirm" onClick={handleRefund}>
                        잔액환불 신청하기
                    </button>
                </div>
            )}

            <main className="container type_gray">
                <section className="bg-white">
                    <div className="inner-box">
                        <BalanceArea
                            className={"main-wallet wallet"}
                            title={"보유 잔액"}
                            balance={Number(refundInfo.prepaidBalance || 0)}
                            expectedBalance={0}
                            expectedBalanceShow={false}
                        />
                    </div>
                </section>

                <section className="bg-white">
                    <div className="inner-box">
                        <div className="form-item">
                            <label className="input-tit big">환불정보</label>
                            <div className="info-row">
                                <span className="label">환불가능금액</span>
                                <span className="cont">{setComma(Math.floor(Number(refundInfo.refundableAmount || 0)))}원</span>
                            </div>
                            <div className="info-row">
                                <span className="label">환불 수수료</span>
                                <span className="cont">{setComma(Math.floor(Number(refundInfo.refundFee || 0)))}원</span>
                            </div>
                            <div className="info-row top-line">
                <span className="label">
                  <strong>실 환불금액</strong>
                </span>
                                <span className="cont">
                  <strong>{setComma(Math.floor(Number(refundInfo.refundAmount || 0)))}원</strong>
                </span>
                            </div>
                        </div>
                        <div className="guide-box mt20">
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                                <h3 className="point-tit" style={{marginBottom: 0}}>잔액환불 가능 조건</h3>
                                <button type="button" className="guide_txt"
                                    style={{textDecoration: 'underline', background: 'none', flexShrink: 0}}
                                    onClick={() => setShowConditionModal(true)}>자세히</button>
                            </div>
                            <ul className="guidF-list mt10">
                                <li>최근 충전 후 1회 이상 사용 이력</li>
                                <li>최근 충전시점의 보유잔액 기준 사용률 {refundInfo.refundUsageRate ?? 60}% 이상 시</li>
                                <li>최근 충전 후 미사용 충전금은 {refundInfo.chargeCancelDays ?? 7}일 이내 충전취소 가능</li>
                            </ul>
                        </div>
                        <div className="guide-box mt20">
                            <h3 className="point-tit">환불 수수료 안내</h3>
                            <ul className="guidF-list">
                                <li>환불 금액 10,000원 이하 : {setComma(Number(refundInfo.refundFeeUnderValue || 0))}{wonAndPercentFormat(refundInfo.refundFeeUnderUnit)}</li>
                                <li>환불 금액 10,000원 초과 : {setComma(Number(refundInfo.refundFeeOverValue || 0))}{wonAndPercentFormat(refundInfo.refundFeeOverUnit)}</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <AccountInfo
                    title={"환불계좌"}
                    depositor={memberWalletInfo?.memberName}
                    accountNo={memberWalletInfo?.accountNo}
                    bankName={memberWalletInfo?.bankName}
                />

                <section className="no-gap">
                    <div className="inner-box">
                        <ul className="guidF-list">
                            <li>잔액환불 신청 후 3영업일 내 환불계좌로 지급됩니다.</li>
                            <li>
                                최근 7일 내 충전 후 미사용한 충전금액은 잔액환불 대상이 아닙니다.
                                (내 지갑 &gt; 충전의 충전 상세내역에서 충전취소 하실 수 있습니다.)
                            </li>
                        </ul>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default RefundPage;
